import { Schema as S } from "effect";

const AvailableTimeSlotSchema = S.Struct({
  start: S.String,
  end: S.String,
  calendarId: S.String,
  scheduleTypeId: S.String,
});

export const GetAvailableTimeSlotsResponseSchema = S.Array(
  AvailableTimeSlotSchema,
);

export type GetAvailableTimeSlotsResponse = S.Schema.Type<
  typeof GetAvailableTimeSlotsResponseSchema
>;
